<template>
  <div class="animated fadeIn">
    <b-row class="custom-header">
      <b-col sm="7" class="title">
        <h3 class="mb-4">{{corporationSelected && corporationSelected.name}}</h3>
      </b-col>
      <b-col v-if="!showFilterButton" sm="5">
        <b-row class="mb-3 mb-sm-0 float-right">
          <b-button variant="primary" class="mt-1" size="sm" @click="initialize()">Carregar</b-button>
        </b-row>
      </b-col>
      <b-col v-if="showFilterButton" sm="5">
        <b-row class="mb-3 mb-sm-0 text-right">
          <b-col xl="10" md="9" sm="8" class="pt-2">
            <small class="text-muted" id="lbl-info">
              <i class="fa fa-filter"></i> De {{formatDate(applyedFilters.dataInicio)}} 
                a {{formatDate(applyedFilters.dataFim)}}
                {{ applyedFilters.signerPj ? "| Ass. PJ" : "" }}
            </small>
          </b-col>
          <b-col xl="2" md="3" sm="4">
            <b-dropdown class="mt-1" menu-class="menu-filter" size="sm" title="Filtro" text="Filtro" variant="primary">
              <b-dropdown-form class="drop-down-filter">
                <h4>Filtrar por</h4>
                <hr>
                <b-form-group label="" label-for="signerPj">
                  <b-form-checkbox id="signerPj" v-model="filters.signerPj" name="signerPj">
                    Assinante PJ
                  </b-form-checkbox>
                </b-form-group>
                <label for="txt-data-inicio" class="mb-0">Período de </label>
                <b-form-input type="date"
                  id="txt-data-inicio"
                  v-model="filters.dataInicio"
                ></b-form-input>
                <label for="txt-data-fim" class="mb-0"> a </label>
                <b-form-input type="date"
                  id="txt-data-fim"
                  v-model="filters.dataFim"
                ></b-form-input>
                <b-button variant="primary" class="mt-3 mb-2" @click="initialize()">Filtrar</b-button>
              </b-dropdown-form>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="showFilterButton">
      <b-col sm="6" :lg="applyedFilters.signerPj ? 4 : 3">
        <b-card no-body class="bg-atual">
          <b-card-body class="pb-0">
            <b-row>
              <b-col sm="9">
                <h4 class="mb-0">{{usuariosCount.destaque.atual}}</h4>
              </b-col>
              <b-col sm="3" class="pt-1 text-right">
                <b-button id="popover-atual-sync" variant="primary" style="background: none; border: none;" size="sm"><i class="nav-icon icon-question"></i></b-button>
              </b-col>
            </b-row>
            <p>Usuários atual</p>
            <b-popover target="popover-atual-sync" title="Número atual de usuários">
              É a quantidade de usuários que estão vinculados à sua corporação atualmente. Esse número diminui quando um usuário é removido e aumenta quando um usuário é adicionado.
            </b-popover>
          </b-card-body>
          <card-line-chart v-if="usuariosCount.loaded" :chart-data="usuariosCount.atual" chartId="card-chart-usuarios-atual" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>

      <b-col sm="6" :lg="applyedFilters.signerPj ? 4 : 3">
        <b-card no-body class="bg-total">
          <b-card-body class="pb-0">
            <b-row>
              <b-col sm="9">
                <h4 class="mb-0">{{usuariosCount.destaque.total}}</h4>
              </b-col>
              <b-col sm="3" class="pt-1 text-right">
                <b-button id="popover-total-sync" variant="primary" style="background: none; border: none;" size="sm"><i class="nav-icon icon-question"></i></b-button>
              </b-col>
            </b-row>
            <p>Usuários total</p>
            <b-popover target="popover-total-sync" title="Número total de usuários">
              É a quantidade de usuários que já foram vinculados à sua corporação. Esse número não diminui quando um usuário é removido, mas aumenta quando um usuário é adicionado.
            </b-popover>
          </b-card-body>
          <card-line-chart v-if="usuariosCount.loaded" :chart-data="usuariosCount.total" chartId="card-chart-usuarios-total" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      
      <b-col sm="6" :lg="applyedFilters.signerPj ? 4 : 3">
        <b-card no-body class="bg-pico">
          <b-card-body class="pb-0">
            <b-row>
              <b-col sm="9">
                <h4 class="mb-0">{{usuariosCount.destaque.pico}}</h4>
              </b-col>
              <b-col sm="3" class="pt-1 text-right">
                <b-button id="popover-pico-sync" variant="primary" style="background: none; border: none;" size="sm"><i class="nav-icon icon-question"></i></b-button>
              </b-col>
            </b-row>
            <p>Usuários pico</p>
            <b-popover target="popover-pico-sync" title="Pico de usuários">
              É a maior quantidade de usuários que estiveram vinculados à sua corporação no dia. Esse número não diminui quando um usuário é removido, porém o usuário removido dá lugar a outro que ao entrar, o número não é incrementado.
            </b-popover>
          </b-card-body>
          <card-line-chart v-if="usuariosCount.loaded" :chart-data="usuariosCount.pico" chartId="card-chart-usuarios-pico" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      
      <b-col sm="6" lg="3" v-if="!applyedFilters.signerPj">
        <b-card no-body class="bg-ativos">
          <b-card-body class="pb-0">
            <b-row>
              <b-col sm="9">
                <h4 class="mb-0">{{usuariosCount.destaque.ativos}}</h4>
              </b-col>
              <b-col sm="3" class="pt-1 text-right">
                <b-button id="popover-ativos-sync" variant="primary" style="background: none; border: none;" size="sm"><i class="nav-icon icon-question"></i></b-button>
              </b-col>
            </b-row>
            <p>Usuários ativos</p>
            <b-popover target="popover-ativos-sync" title="Usuários ativos">
              É o número correspondente apenas aos usuários que realizaram algum tipo de operação (autenticação ou assinatura) nos dias apresentados.
            </b-popover>
          </b-card-body>
          <card-line-chart v-if="volumes.loaded" :chart-data="usuariosCount.ativos" chartId="card-chart-usuarios-ativos" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
    </b-row>

    <b-card v-if="!applyedFilters.signerPj && showFilterButton">
      <b-row>
        <b-col sm="5">
          <h3 id="traffic" class="card-title mb-0">Volumes</h3>
          <!-- <div class="small text-muted">Setembro 2019</div> -->
        </b-col>
      </b-row>
      <volumes-chart chartId="volumes-chart" class="chart-wrapper" style="height:300px;margin-top:20px;" height="300" v-if="volumes.loaded" :chart-data="volumes.data"></volumes-chart>
      <div slot="footer">
        <b-row class="text-center">
          <b-col class="mb-sm-2 mb-0">
            <strong>{{this.volumes.totais.assinaturas}} Assinaturas</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="assinaturas" :value="50"></b-progress>
          </b-col>
          <b-col class="mb-sm-2 mb-0">
            <strong>{{this.volumes.totais.autenticacoes}} Autenticações</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="autenticacoes" :value="50"></b-progress>
          </b-col>
          <b-col v-if="this.volumes.totais.carimbosTempo > 0" class="mb-sm-2 mb-0">
            <strong>{{this.volumes.totais.carimbosTempo}} Carimbos Tempo</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="carimbosTempo" :value="50"></b-progress>
          </b-col>
          <b-col v-if="this.volumes.totais.assinaturasHub > 0" class="mb-sm-2 mb-0">
            <strong>{{this.volumes.totais.assinaturasHub}} Assinaturas HUB</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="assinaturasHub" :value="50"></b-progress>
          </b-col>
          <b-col v-if="this.volumes.totais.autenticacoesHub > 0" class="mb-sm-2 mb-0">
            <strong>{{this.volumes.totais.autenticacoesHub}} Autenticações HUB</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="autenticacoesHub" :value="50"></b-progress>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import CardLineChart from './dashboard/CardLineChart'
import VolumesChart from './dashboard/VolumesChart'
import axios from 'axios'
import { requestError, env, isAllowed, formatDate } from '@/shared/utils'
import _ from 'underscore'
import { mapState } from 'vuex'
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'dashboard',
  components: {
    CardLineChart,
    VolumesChart
  },
  data: function () {
    let dtInicio = new Date();
    dtInicio.setDate(dtInicio.getDate() - 10);
    return {
      showFilterButton: false,
      filters: {
        dataInicio: dtInicio.toISOString().substr(0, 10),
        dataFim: new Date().toISOString().substr(0, 10),
        signerPj: false
      },
      applyedFilters: {
        dataInicio: dtInicio.toISOString().substr(0, 10),
        dataFim: new Date().toISOString().substr(0, 10),
        signerPj: false
      },
      usuariosCount: {
        loaded: false,
        total: null,
        atual: null,
        pico: null,
        ativos: null,
        destaque: {}
      },
      volumes: {
        loaded: false,
        data: null,
        totais: {}
      },
      helpers: {
        atual: false,
        total: false,
        pico: false,
        ativos: false
      }
    }
  },
  async mounted () {
    if (!isAllowed('has_corporation')) {
      return this.$router.replace({path: '/clean'});
    }
  },
  beforeDestroy() {
    this.clearData();
  },
  computed: {
    ...mapState(['corporationSelected'])
  },
  watch: {
    async corporationSelected(corporation) {
      await this.clearData();
    }
  },
  methods: {
    async initialize () {
      this.showFilterButton = true;
      this.usuariosCount.loaded = false;
      this.volumes.loaded = false;
      this.applyedFilters = Object.assign({}, this.filters);
      await this.getUsersCount();
      await this.getOperationCount();
    },
    async clearData () {
      this.showFilterButton = false;
      this.usuariosCount.loaded = false;
      this.usuariosCount.destaque.atual = null;
      this.usuariosCount.destaque.total = null;
      this.usuariosCount.destaque.pico = null;
      this.usuariosCount.destaque.ativos = null;

      this.volumes.loaded = false;
      this.volumes.data = [];
      this.volumes.totais.assinaturas = null;
      this.volumes.totais.autenticacoes = null;
      this.volumes.totais.carimbosTempo = null;
      this.volumes.totais.assinaturasHub = null;
      this.volumes.totais.autenticacoesHub = null;
    },
    formatDate(date) {
      return formatDate(date, "dd/MM/yyyy");
    },
    async getUsersCount () {
      let _this = this;
      const loader = _this.$loading.show();
      let userClass = this.applyedFilters.signerPj ? "user_signer" : "user_corporation";
      await axios
        .get(`${env.urlBillingApi}/users-count?initDate=${this.applyedFilters.dataInicio}&endDate=${this.applyedFilters.dataFim}&userClass=${userClass}`)
        .then(function(response) {
          _this.usersCount = {};
          let sortedUsers = _.sortBy(response.data._embedded.users_count, (itm) => itm.day.date);
          for (let k in sortedUsers) {
            let itm = sortedUsers[k];
            let split = itm.day.date.match(/(\d{4})-(\d{2})-(\d{2})/).slice(2);
            _this.usersCount[split.reverse().join("/")] = {
              currentUsers: itm.currentUsers,
              peakUsers: itm.peakUsers,
              totalUsers: itm.totalUsers
            };
          };
          _this.fillChartDataUsersCount();
          _this.usuariosCount.loaded = true;
          console.log(response.data);
          loader.hide();
        })
        .catch(function(error) {
          requestError(error);
          loader.hide();
        })
        .finally(() => {
          _this.loadCount--;
          loader.hide();
        });
    },

    fillChartDataUsersCount() {
      let labels = Object.keys(this.usersCount);
      let values = Object.values(this.usersCount);
      this.usuariosCount.atual = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários atual',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.currentUsers)
          }
        ]
      }
      this.usuariosCount.total = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários total',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.totalUsers)
          }
        ]
      }
      this.usuariosCount.pico = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários pico',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.peakUsers)
          }
        ]
      }

      this.usuariosCount.destaque.atual = values.length == 0 ? 0 : parseInt(values[values.length - 1].currentUsers);
      this.usuariosCount.destaque.total = values.length == 0 ? 0 : parseInt(values[values.length - 1].totalUsers);
      this.usuariosCount.destaque.pico = values.length == 0 ? 0 : parseInt(values.reduce(function(a, b) { 
          return (parseInt(a.peakUsers) > parseInt(b.peakUsers)) ? a : b;
        }).peakUsers);
    },

    async getOperationCount () {
      let _this = this;
      const loader = _this.$loading.show();
      await axios
        .get(`${env.urlBillingApi}/operation-count?initDate=${this.applyedFilters.dataInicio}&endDate=${this.applyedFilters.dataFim}`)
        .then(function(response) {
          _this.operationCount = {};
          let sortedOperations = _.sortBy(response.data._embedded.operation_count, (itm) => itm.day.date);
          for (let k in sortedOperations) {
            let itm = sortedOperations[k];
            let split = itm.day.date.match(/(\d{4})-(\d{2})-(\d{2})/).slice(2);
            let day = split.reverse().join("/");
            _this.operationCount[day] || (_this.operationCount[day] = {});
            _this.operationCount[day][itm.operationType] = itm.count;
          };
          _this.fillChartDataOperationCount();
          _this.volumes.loaded = true;
          console.log(response.data);
          loader.hide();
        })
        .catch(function(error) {
          requestError(error);
          loader.hide();
        })
        .finally(() => {
          loader.hide();
        });
    },

    fillChartDataOperationCount() {
      let labels = [], values = [];
      for (const day in this.operationCount) {
        const value = this.operationCount[day];
        if (value.any != null) {
          labels.push(day);
          values.push(value);
        }
      }
      this.usuariosCount.ativos = {
        labels: labels,
        datasets: [
          {
            label: 'Usuários ativos',
            backgroundColor: 'rgba(255,255,255,.55)',
            fill: false,
            borderColor: 'rgba(255,255,255,.55)',
            data: values.map((itm) => itm.any)
          }
        ]
      }
      if (!values.length) {
        this.usuariosCount.destaque.ativos = 0;
      } else {
        this.usuariosCount.destaque.ativos = parseInt(values[values.length - 1].any);
      }

      labels = Object.keys(this.operationCount);
      values = Object.values(this.operationCount);
      this.volumes.data = {
        labels: labels,
        assinaturas: values.map((itm) => parseInt(itm.signature || 0)),
        autenticacoes: values.map((itm) => parseInt(itm.login || 0)),
        carimbosTempo: values.map((itm) => parseInt(itm.timestamp || 0)),
        assinaturasHub: values.map((itm) => parseInt(itm.hub_sign || 0)),
        autenticacoesHub: values.map((itm) => parseInt(itm.hub_auth || 0)),
      }
      this.volumes.totais = {
        assinaturas: values.reduce((mem, itm) => mem + parseInt(itm.signature || 0), 0),
        autenticacoes: values.reduce((mem, itm) => mem + parseInt(itm.login || 0), 0),
        carimbosTempo: values.reduce((mem, itm) => mem + parseInt(itm.timestamp || 0), 0),
        assinaturasHub: values.reduce((mem, itm) => mem + parseInt(itm.hub_sign || 0), 0),
        autenticacoesHub: values.reduce((mem, itm) => mem + parseInt(itm.hub_auth || 0), 0),
      }
    },
  }
}
</script>

<style lang="scss">
  .custom-header button {
    font-family: 'Helvetica-Bold' !important;
  }
</style>

<style lang="scss" scoped>
  /* IE fix */
  #card-chart-usuarios-atual, #card-chart-usuarios-total, #card-chart-usuarios-pico, #card-chart-usuarios-ativos, #volumes-chart {
    width: 100% !important;
  }
  .bg-ativos {
    background-color: #6b79ab;
    border: 1px solid #6b79ab;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .bg-pico {
    background-color: #5f6fa7;
    border: 1px solid #5f6fa7;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .bg-total {
    background-color: #5869a7;
    border: 1px solid #5869a7;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .bg-atual {
    background-color: #5164a9;
    border: 1px solid #5164a9;
    font-family: 'Helvetica-Bold';
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 19px -2px rgba(0,0,0,0.75);
  }
  .card-body h4 {
    font-size: 45px !important;
  }
  .card-body p {
    font-family: 'Helvetica-Light';
  }
  .title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
